module.exports = require("./ar-KM.d.ts");